module.exports = __webpack_public_path__ + "img/ic_topic_trends-active.936ac0dc.svg";